import { inheritsLoose as _inheritsLoose } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { cloneElement, Component } from 'react';
import get$1 from 'lodash/get';
import ReactDOM$1 from 'react-dom';
import getRootNode$1 from 'get-root-node-polyfill';
import PortalContext$1 from './PortalContext.js';

var getRoot = function getRoot(_ref) {
  var anchorNode = _ref.anchorNode;
  return anchorNode ? getRootNode$1.call(anchorNode) : document;
};

var getRootElement = function getRootElement(opts) {
  var rootElem = getRoot(opts);
  return get$1(rootElem, 'body', rootElem);
};

var Portal = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Portal, _Component);

  function Portal() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Portal.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    var rootNode = getRootElement(this.props);

    if (this.defaultNode && rootNode && rootNode.contains(this.defaultNode)) {
      rootNode.removeChild(this.defaultNode);
    }

    this.defaultNode = null;
    this.portal = null;
  };

  _proto.render = function render() {
    var rootNode = getRootElement(this.props);

    if (!this.props.node && !this.defaultNode) {
      this.defaultNode = document.createElement('div');
      rootNode.appendChild(this.defaultNode);
    }

    var children = this.props.children; // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b

    if (typeof this.props.children.type === 'function') {
      children = /*#__PURE__*/cloneElement(this.props.children);
    }

    return /*#__PURE__*/React__default.createElement(PortalContext$1.Provider, {
      value: true
    }, /*#__PURE__*/ReactDOM$1.createPortal(children, this.props.node || this.defaultNode));
  };

  return Portal;
}(Component);

Portal.displayName = 'Portal';

export default Portal;
